<template>
    <div class="pay">
      <header-com/>
      
      <select-address v-if='detail.entrance == "BOOKINGS" && !isActive' class='address' @changeType='changeType' :sendFrom='sendFrom' @changeAdr='changeAdr' @changeDate='changeDate' @action='action' ref='setAdr'></select-address>
      <div class="block" v-if='detail.entrance == "BOOKINGS" && !isActive'></div>
      <div class='goodsList' :class='{mt104:(detail.entrance != "BOOKINGS") || isActive }'>
        <div>
          <span class='title'>订单信息</span>
        </div>
        <div class='img_cont'>
          <div>
            <img v-for='(item,index) in goodsList' :key='index' :src="setImg(item)" v-if='index <=3' class='item_icon'>
          </div>
          <div class='moreGoods' @click='moreGoodsShow'>
            <span>共{{goodsList.length}}件</span>
            <img src="/images/base/threemore.png" class='moreTips'>
          </div>
        </div>
      </div>
      <div class="block"></div>
      <div class="container">

        <div class="pay-info">
          <li>
            <span class="f26">订单金额</span>
            <span class="f30 bold">¥{{detail.amount}}</span>
          </li>
          <li v-for='(item,index) in settlementDiscount'>
            <span class="f26">{{item.name}}<span class='prefere' v-if='item.discountList && item.discountList.length !=0' v-for='(data,dataIndex) in item.discountList'>{{data.name}}</span></span>
            <span class="f30 bold reds">{{item.value}}</span>
          </li>
        </div>
        <div class="block"></div>
        <div class="pay-style">
          <li @click='payType=true'>
            <img class="icon" src="/images/order/wechat.png" alt="" />
            <div class="name" :class='{borderNone:isWeiXin}'>微信支付</div>
            <div class="radio" v-if='!isWeiXin'><radio :checked='payType'/></div>
          </li>
          <li @click='payType=false' v-if='!isWeiXin'>
            <img class="icon alipay" src="/images/order/alipay.png" alt="" />
            <div class="name">支付宝支付</div>
            <div class="radio"><radio :checked='!payType'/></div>
          </li>
        </div>
        <div class="block"></div>
      </div>
      <div class="g-fixed-bottom toolbar">
        
        <!-- <button class="primary" @click='confirm'>取消</button> -->
        <div class='toolbar_first'>
            <button class="secondary" @click='concel'>取消</button>
            <button class="primary" @click='confirm' :disabled='paying'>立即支付</button>
        </div>
        
        <div class='toolbar_sec'>实付：¥<span class='money'>{{detail.realAmount}}</span></div>
      </div>


      <!-- 商品详情-->
      <van-popup position="bottom" v-model="goodsShow">
          <div class="containers f28">
            <div class="title">订单信息<span class='goodsnum'>共{{goodsList.length}}件</span></div>
            <div class="close" @click="goodsShow=false"></div>
            <div class='item_content'>
              <goods-item v-for='(item,index) in goodsList' :key='index' :model='item' :class='{paddingp:index=goodsList.length -1}'></goods-item>

            </div>
          </div>
      </van-popup>
    </div>
</template> 

<script>
  import myApi from '@/axios/my'
  import payObj from '@/assets/js/pay'
  import { Toast,Dialog } from 'vant';
  import publicObj from '@/assets/js/public'
  import orderApi from '@/axios/order'
  import zhugeObj from '@/assets/js/track'
  export default {
    name: 'index',
    data () {
      return {
        goodsShow : false,
        detail : {
          entrance : ''
        },
        payType : true,
        goodsList : [],
        settlementDiscount : [],
        paying : false,
        sendFrom : {
          sendType : 40,
          customerAddressId : '',
          pickingDate : '',
          pickingTime : '',
        },
        code : '',
        isActive : false
      }
    },
    created () {
      this.code = this.$route.query.code;
      this.isWeiXin = publicObj.isWeiXin();

      this.getstatements();
      this.isActive = this.$route.query.type?true:false;
      if(this.isActive){
        this.sendFrom.sendType = 10
      }
    },
    computed:{
     
    },
    methods: {
        action(){
          this.confirm();
        },
        changeDate(data,time){
          this.sendFrom.pickingDate = data;
          this.sendFrom.pickingTime = time;
        },
        changeAdr(element){

          this.sendFrom.customerAddressId = element.id;
        },
        changeType(index){
          this.sendFrom.sendType = index;
        },  
        getstatements(){
            orderApi.settlemenDetail(this.code).then((res)=>{
                this.detail = res;
                this.goodsList = res.goodsList;
         
                this.settlementDiscount = res.settlementDiscount;
                
                
            })

        },
        
        formatImgUrl(url, width, height,m_fill) {
            // console.log(url)
            if (url) {
            url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
            // url = url.replace(',jpg', ",webp");
            url +=',q_80';
            if(m_fill){
                // console.log(m_fill)
                url = url.replace('m_lfit', "m_fill");
            }
            }
            return url
        },
        setImg(item){
            if(item.goodsType == 'goods'){
                return this.formatImgUrl(item.picTemplate,300,300,true)
            }else{
                if(item.categoryId == 3){
                  return '/images/newOrder/package1.png'
                }else if(item.categoryId == 4){
                  return '/images/newOrder/shoes1.png'
                }else if(item.categoryId == 5){
                  return '/images/newOrder/pajamas1.png'
                }else if(item.categoryId == 6){
                  return '/images/newOrder/accessories1.png'
                }else{
                  return '/images/base/defult_pic.png'
                }
            }
        },
        moreGoodsShow(){
            this.goodsShow = true;

        },
        // {{coupon?coupon.couponName:'选择优惠券'}}

        concel(){
            Dialog.confirm({
                title: '',
                message: '您确认要取消么?'
            }).then(() => {                                                          
                orderApi.settlementConcel(this.detail.settlementCode).then(()=>{
                    this.$router.back();
                })
            }).catch(() => {
                // on cancel
               
            });
            
        },
        
        confirm(){
            let payParams = payObj.getPayParams(this.payType);
            //额外获取OPID
            const openId = localStorage.getItem('openId');
            
            let params = {
                paymentPlatform:payParams.payChannel,
                settlementCode : this.detail.settlementCode,
                openId : openId
            }

            if(this.isWeiXin && !openId){
            
              Dialog.confirm({
                  title: '',
                  message: '网络开小差啦，请重新登录后再试！'
              }).then(() => {                                                          
                  sessionStorage.setItem('url', location.href)
                  this.$store.commit('token', '');
                  localStorage.clear();
                  location.replace(location.origin + '/login');
              }).catch(() => {
                  // on cancel

              });
              return;
            }

            params.backUrl = payParams.backUrl + '?type=3'

            //整理新的邮递信息参数
       
            params.entrance = this.detail.entrance;
            if(this.detail.entrance == 'BOOKINGS'){
                params.bookingsOrderCode = this.detail.orderCode;
            }

            params.pickingWay = this.sendFrom.sendType;
            if(params.pickingWay == 40 && this.detail.entrance == 'BOOKINGS'){

             
              params.pickingDate = this.sendFrom.pickingDate;
              params.pickingTime = this.sendFrom.pickingTime;
              params.customerAddressId = this.sendFrom.customerAddressId;

              //参数验证
              if(!params.customerAddressId){
                 Toast('请选择地址');
                 return;
              }

              if(!params.pickingDate){
                 Toast('请选择上门时间');
                 this.$refs.setAdr.timeShowAction(1);
                 return;
              }
            }

            this.paying = true;
            orderApi.settlementCodePayment(params).then((res)=>{
                if(res.realAmount == 0){
                    this.$router.push({name:'paySuccess',query:{type:3}});
                    return;
                }
                if(params.paymentPlatform == "WeChat_h5"){
                    window.location.href = res.paymentData.h5PayUrl;
                    return;
                }
                
                if(params.paymentPlatform == "AliPay_h5"){
                    window.location.href = res.paymentData.h5PayUrl;
                    return;
                }
                this.paying = false;
                payObj.confirmPay(payParams.payChannel,res.paymentData,3,function(){
                    this.$router.back();
                });
            }).catch((res)=>{
     
              this.paying = false;
            })
        } 
    }
  }
</script>

<style scoped lang="scss">
    .mt104{
      margin-top: 84px;
    }
    .address{
      margin-top: 84px;
    }
    .secondary{
        margin-right: 15px;
        position: relative;
        top:3px;
    }
  .payTypeOther{
    display: flex;
    &>div{
      display: flex;
      line-height: 33px;
      margin-left: 20px;
      vertical-align: middle;
      &>div{
        position: relative;
        top:5px;
        margin-left: 10px;
      }
    }
  }
  .gift_num{
    line-height: 30px;
    margin-top: 22px;
  }
  .gift_title{
    font-size: 30px;
    font-weight: 500;
  }
  .gift_list{
    display: flex;
    justify-content: flex-start;
    font-size: 26px;
    line-height: 30px;
    margin-top: 22px;
  }
  .borderNone{
    border: none!important;
  }
  .reds{
    color:#F56D6D;
  }
  .prefere{
    display: inline-block;
    background:#173657;
    font-size:18px;
    border-radius:4px; 
    color:#fff;
    margin-left: 8px;
    position: relative;
    top:-4.6px;
    padding:5px 20px;
  }
  .paddigleft{
    padding-left: 70px!important;
  }
  .couponRadio{
    position: absolute;
    top:41%;
    left: 40px;
  }
  .alipay{
    width: 52px!important;
    height: 52px!important;
  }
  .paddingp{
    padding-bottom: 100px!important;
  }
  .moreGoods{
    display: flex;
    align-items: center;
  }
  .moreTips{
    width: 40px;
    margin-left:16px;
  }
  .item_content{
    max-height: 950px;
    overflow-y: scroll;
  }
  .goodsList{
    padding-top:20px;
    display: flex;
    justify-content: center;
    // padding-bottom: 20px;
    // box-shadow:0px 8px 60px 0px rgba(0,0,0,0.1);
    // border-radius:0px 0px 20px 20px;
    flex-wrap: wrap;
    margin-bottom: 40px;
    &>div{
      width: 670px;
    }
    .title{
      font-size:30px;
      font-weight:500;  
      line-height: 60px;
    }
    .img_cont{
      display: flex;
      justify-content: space-between;
      margin-top: 16px;
    }
    .item_icon{
      width:120px;
      height: 120px;
      border-radius: 8px;
      margin-right: 10px;
    }
  }
  .postage{
    position: fixed;
    
    color:#C4AB6A;
    width: 100%;
    bottom:110px;
    line-height: 48px;
    font-size:24px; 
    border-radius:12px 12px 0px 0px;
    text-indent: 70px;
    background: url("/images/order/smile.png") 20px center no-repeat;
    background-size:30px; 
    background-color: #FFE7A7;
  }
  .describe{
 
    margin-top:10px;
  }
  .time{
    display: inline-block;
    margin-top: 15px;
  }
  .conpentitle{
    font-size:60px; 
  }
  .my_button{
    width: 350px;
    height: 84px;
    line-height: 84px;
    min-width: 224px;
    text-align: center;
    font-size: 32px;
    background: $primary-color;
    color: $white-color;
    border-radius:44px;
    margin-top:30px;
    float: right;
    margin-right: 30px;
    margin-bottom: 30px;
  }
  .border-bottom{
    border-bottom: 1px solid #CECECE;
  }
  .title_text{
    font-size: 30px;
    font-weight:500;
    line-height: 50px;
    margin-bottom: 24px; 
  }
  .pay{
    padding-bottom: 150px;
  }
  .toolbar{
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: space-between;
    padding-top:0;
    div{
      // width: 45%;
      font-size: 22px;
      color:rgba(250, 81, 81, 0.8);
      span{
        font-size: 35px;
      }
    }
    .toolbar_first{
      display: flex;
      // width: 300px!important;
      justify-content: flex-start;
    }
    .toolbar_sec{
      width: 400px;
    }
  }
  .money{
    font-weight:500;
    margin-left: 10px; 
  }
  .copyright_content{
    display: flex;
    justify-content: center;
  }
  .copyright{
    display: flex;
    justify-content: flex-start;
    width: 670px;
    color:#999999;
    font-size:25px;
    margin-top: 44px; 
    line-height: 35px;
    span{
      color: $theme-color;
      text-decoration: underline;
      text-underline: $theme-color;
    }
  }
  .fwnolmol{
    font-size:28px;
    font-weight:normal; 
    line-height: 30px;
  }
  .container{
    // padding-top: 134px;
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .amount,.coupon{
      width: 670px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 26px;
      span{
        line-height: 42px;
        &.right{
          padding-right: 30px;
          background: url("/images/public/arrow-right.png") no-repeat right center;
          background-size: 14px 22px;
        }
      }
    }
    .amount{
      margin-bottom: 40px;
    }
    .pay-info{
      padding: 40px 0;
      width: 670px;
      li{
        display: flex;
        justify-content: space-between;
        margin-bottom: 26px;
        font-size: 26px;
        color:#333;
        &:last-child{
          margin-bottom: 0;
        }
      }
    }
    .pay-style{
      padding: 40px 0;
      padding-bottom: 0;
      width: 670px;
      li{
        display: flex;
        align-items: center;
        margin-bottom: 40px;
        .icon{
          width: 52px;
          height: 48px;
          object-fit: cover;
          margin-right: 44px;
          flex: none;
        }
        .name{
          width: 480px;

          border-bottom: 2px solid #eee;
          flex: none;
          font-size:28px;
          color:#333333; 
          line-height: 52px;
        }
        .radio{
          margin-left: 40px;
          flex: none;
        }
      }
    }
    .copyright{
      display: flex;
      align-items: center;
      padding-top: 46px;
      div{
        margin-right: 20px;
      }
      span{
        color: $theme-color;
        text-decoration: underline;
        text-underline: $theme-color;
      }
    }
  }
  

  .goodsnum{
    margin-left:16px;
    color:#999999;
    font-size: 24px;
  }
  .van-popup--bottom{
    width: 101%;
  }
  .containers{
    // height: 1000px;
    padding-top: 30px;
    padding-bottom:30px;
    position: relative;
    max-height: 1000px;
    .title{
      line-height: 40px;
      margin-bottom: 30px;
      margin-left: 30px;
      margin-right: 30px;
      font-weight: 500;
    }
    ul{
      // position: absolute;
      // top: 100px;
      left: 0;
      bottom: 0;
      // overflow-y: scroll;
      width: 100%;
      max-height: 800px;
      overflow-y: scroll;
      padding-bottom: 10px;
      padding-top:10px;
      li{
        height: 200px;
        padding: 20px;
        padding-left: 20px;
        padding-right: 20px;
        // margin-bottom: -20px;
        /*border-radius:100px;*/
        background: no-repeat left top;
        background-size: 100%;
        position: relative;
        .inner{
          width: 420px;
          padding: 6px 40px 0;
        }
        h3{
          font-size: 60px;font-weight: bold;
          line-height: 84px;
        }
        h4{line-height: 34px}
        h5,time{line-height: 28px}
      }
    }
    .bottom{
      position: absolute;
      width: 690px;
      bottom: 30px;
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      .submit{
        margin-left: 20px;
      }
    }
    .close{
      width: 36px;
      height: 36px;
      position: absolute;
      top: 30px;
      right: 30px;
      background: url("/images/public/close.png") no-repeat center;
      background-size: 32px;
    }
  }
</style>
